import { callRpc } from './base';

export interface ProgramContactsData {
  program_id: string;
  program_name: string;
  awarding_organization: string | null;
  baci_code: string;
  contact_id: string | null;
  contact_name: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  physical_address: string | null;
  contact_notes: string | null;
  qc_flag_contacts: boolean;
  qc_flag_contacts_notes: string | null;
  seed_url: string | null;
  website_url: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface UpdateProgramContactsParams {
  program_id: string;
  contact_name?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
  physical_address?: string | null;
  contact_notes?: string | null;
  qc_flag_contacts?: boolean | null;
  qc_flag_contacts_notes?: string | null;
  editor_id?: string | null;
}

export interface UpdateProgramContactsResult {
  program_id: string;
  program_code: string;
  updated_at: string;
  changes: Record<string, { before: any; after: any }>;
  contact_id: string;
}

/**
 * Fetch program details with contact information and QC flags
 */
export const getProgramContacts = async (
  programId: string
): Promise<ProgramContactsData> => {
  return await callRpc<ProgramContactsData, ProgramContactsData>('get_program_contacts', {
    params: {
      p_program_id: programId
    },
    successMeta: (result) => ({
      program_id: result.program_id,
      baci_code: result.baci_code
    })
  });
};

/**
 * Update contact information for a program
 * Only updates fields that are provided (non-null)
 */
export const updateProgramContacts = async (
  params: UpdateProgramContactsParams
): Promise<UpdateProgramContactsResult> => {
  const rpcParams: Record<string, any> = {
    p_program_id: params.program_id
  };

  if (params.contact_name !== undefined) rpcParams.p_contact_name = params.contact_name;
  if (params.contact_email !== undefined) rpcParams.p_contact_email = params.contact_email;
  if (params.contact_phone !== undefined) rpcParams.p_contact_phone = params.contact_phone;
  if (params.physical_address !== undefined) rpcParams.p_physical_address = params.physical_address;
  if (params.contact_notes !== undefined) rpcParams.p_contact_notes = params.contact_notes;
  if (params.qc_flag_contacts !== undefined) rpcParams.p_qc_flag_contacts = params.qc_flag_contacts;
  if (params.qc_flag_contacts_notes !== undefined) rpcParams.p_qc_flag_contacts_notes = params.qc_flag_contacts_notes;
  if (params.editor_id !== undefined) rpcParams.p_editor_id = params.editor_id;

  return await callRpc<UpdateProgramContactsResult, UpdateProgramContactsResult>(
    'update_program_contacts',
    {
      params: rpcParams,
      successMeta: (result) => ({
        program_id: result.program_id,
        changes_count: Object.keys(result.changes).length
      })
    }
  );
};
